import { Link, useLocation } from "react-router-dom"
import "./product.css"
import Chart from "../../components/chart/Chart"
import { productData } from "../../dummyData"
import { Publish, Close } from "@material-ui/icons"
import { useSelector, useDispatch } from "react-redux"
import { useEffect, useState } from "react"
import { serverAPI } from "../../services/apiParams"
import { Snackbar, IconButton } from "@mui/material"
import DropdownMenu from "../../components/dropdown menu categories/DropdownMenuCategories"
import { getProducts } from "../../redux/apiCalls"
import { renderErrorMsg } from "../../services/errorsForm"
import { onImageUpload } from "../../services/uploadImage"

//add a new category
export default function Product() {
  const [sales, setSales] = useState()
  const [productForm, setProductForm] = useState()
  const location = useLocation()
  const [formErrorMsg, setFormErrorMsg] = useState()
  const productId = location.pathname.split("/")[2]
  const product = useSelector((state) => {
    return state.product.products.find((product) => {
      return String(product.id) === productId
    })
  })
  const dispatch = useDispatch()
  const [productImage, setProductImage] = useState()

  // upload image
  const [imageUrl, setImageUrl] = useState()
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false)

  useEffect(() => {
    const getSales = async () => {
      try {
        const res = await serverAPI.get(`api/products/${productId}/sales`)
        setSales(res.data)
      } catch (error) {
        console.log(error.response)
      }
    }
    product && getSales()
  }, [product])

  const handleChangeImage = (e) => {
    onImageUpload(e, setSubmitBtnDisabled, setFormErrorMsg, setImageUrl)
  }
  //updata product information
  const handleChangeForm = (e) => {
    setProductForm({
      ...productForm,
      [e.target.name]: e.target.value,
    })
  }
  const editProduct = async (e) => {
    e.preventDefault()

    const editedProduct = { ...productForm, image: imageUrl }

    try {
      const res = await serverAPI.post(
        `api/products/${productId}`,
        editedProduct
      )
      // if updated true display snackbar
      res.data.updated && handleClick()
      setProductForm({})
      // update Store.products after editing product's data
      getProducts(dispatch)
      //reset inputs after submit
      document.getElementById("editProductForm").reset()
    } catch (error) {
      setFormErrorMsg(error.response.data.errors)
    }
  }
  // snackbar when product is updated
  const [open, setOpen] = useState(false)
  const handleClick = () => {
    setOpen(true)
  }
  const handleClose = (reason) => {
    if (reason === "clickaway") {
      return
    }
    setOpen(false)
  }
  const closeSnackbarButton = (
    <IconButton
      size='small'
      aria-label='close'
      color='inherit'
      onClick={handleClose}>
      <Close fontSize='small' color='white' />
    </IconButton>
  )
  return (
    <div className='product'>
      <div className='productTitleContainer'>
        <h1 className='productTitle'>Product</h1>
        <Link to='/newproduct'>
          <button className='productAddButton'>Create</button>
        </Link>
      </div>
      <div className='productTop'>
        <div className='productTopLeft'>
          <Chart data={productData} dataKey='Sales' title='Sales Performance' />
        </div>
        <div className='productTopRight'>
          <div className='productInfoTop'>
            <img src={product.image} alt='' className='productInfoImg' />
            <span className='productName'>{product.title}</span>
          </div>
          <div className='productInfoBottom'>
            <div className='productInfoItem'>
              <span className='productInfoKey'>id: {product.id}</span>
              <span className='productInfoValue'>123</span>
            </div>
            <div className='productInfoItem'>
              <span className='productInfoKey'>sales:</span>
              <span className='productInfoValue'>{sales}</span>
            </div>
            <div className='productInfoItem'>
              <span className='productInfoKey'>in stock:</span>
              <span className='productInfoValue'>{product.stock}</span>
            </div>
          </div>
        </div>
      </div>
      <div className='productBottom'>
        <form className='productForm'>
          <div className='productTopLeft'>
            <form className='addProductForm' id='editProductForm'>
              <div className='addProductItem'>
                <label>Name</label>
                <input
                  type='text'
                  placeholder={product.title}
                  name='title'
                  onChange={handleChangeForm}
                />
                {renderErrorMsg(formErrorMsg, "title")}
              </div>
              <div className='addProductItem'>
                <label>Description</label>
                <input
                  type='text'
                  placeholder={product.description}
                  name='description'
                  onChange={handleChangeForm}
                />
                {renderErrorMsg(formErrorMsg, "description")}
              </div>
              <div className='addProductItem'>
                <DropdownMenu
                  handleChangeForm={handleChangeForm}></DropdownMenu>
              </div>

              <div className='addProductItem'>
                <label>Price</label>
                <input
                  placeholder={product.price}
                  name='price'
                  onChange={handleChangeForm}
                />
                {renderErrorMsg(formErrorMsg, "price")}
              </div>
              <div className='addProductItem'>
                <label>Stock</label>
                <input
                  placeholder={product.stock}
                  name='stock'
                  onChange={handleChangeForm}
                />
                {renderErrorMsg(formErrorMsg, "stock")}
              </div>
              <button
                className='addProductButton'
                onClick={editProduct}
                disabled={submitBtnDisabled}>
                Edit
              </button>
            </form>
          </div>
          <div className='productFormRight'>
            <div className='productUpload'>
              <img
                src={product.image}
                alt=''
                className='productUploadImg'
                name='image'
              />
              <label for='file'>
                <Publish />
              </label>
              <input
                type='file'
                id='file'
                style={{ display: "none" }}
                onChange={handleChangeImage}
              />
              {renderErrorMsg(formErrorMsg, "image")}
            </div>
          </div>
        </form>
      </div>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message='Product Updated'
        action={closeSnackbarButton}
      />
    </div>
  )
}
